<mat-form-field>
  <mat-label>{{placeholder}}</mat-label>
    <mat-select [(value)]="value" [compareWith]="compareWith" [disabled]="disabled" [formControl]="ChildControl" [multiple]="multiple"
                [required]="required" name="Status">
      <mat-option *ngIf="blancoOption"></mat-option>
      <mat-option *ngIf="emptyOption" [value]="'empty'">(Empty)</mat-option>
        <ng-container *ngFor="let option of DropdownOptions">
            <mat-optgroup *ngIf="option.IsTitle" [label]="option.Value">
                <mat-option *ngFor="let opt of option.DropdownOptions" [value]="getOnlyId ? opt.Id : opt">
                    {{opt.Value}}
                </mat-option>
            </mat-optgroup>
          <mat-option *ngIf="!option.IsTitle" [disabled]="!!option.IsDisabled" [value]="getOnlyId ? option.Id : option"
                      [style.background-color]="option.Color && displayColors ? option.Color : false">
            {{option.getTranslation() !== 'NO_TRANSLATION' ? option.getTranslation() : option.Value}}
          </mat-option>
        </ng-container>
    </mat-select>
    <button (click)="$event.stopPropagation(); value = multiple ? [] : null" [disabled]="disabled" mat-icon-button matIconSuffix type="button">
      <mat-icon>clear</mat-icon>
    </button>
    <span matSuffix [ngTemplateOutlet]="matSuffix"></span>
  <mat-hint *ngIf="mathint">{{mathint}}</mat-hint>
</mat-form-field>
